module.exports = __webpack_public_path__ + "img/logo1.c49ffabd.png";